﻿$.fn.dxCtrlContentEmailRecu = function custom_dxCtrlContentEmailRecu(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentemailrecu dx-ctrl");
        this.createInstance(new cdxCtrlContentEmailRecu(this, option));
    }
    return this;
}

window.cdxCtrlContentEmailRecu = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivEntete = null;
    var jauge = null
    function mConstruit() {
        container.empty()

        if (option.data.nouveau == "1") {
            option.data.nouveau = "0"
            option.bddCtrl.getObjet(option.data).mSaveChamp("nouveau")
        }

        if (container.closest(".dx-popup-normal").length > 0) {
            jauge = $("<div/>").appendTo($(container.closest(".dx-popup-normal")[0])).dxCtrlJauge({}).dxCtrlJauge("instance")
        } else if (container.closest(".dx-ctrlpagepopupdiv").length > 0 && $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup != null) {
            jauge = $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup.jauge
        } else {
            jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        }
        jauge.mShow()
        //jauge = $("<div/>").appendTo(((container.closest(".dx-popup-normal").length > 0) ? $(container.closest(".dx-popup-normal")[0]) : ((container.closest(".dx-ctrlpagepopupdiv").length > 0) ? $(container.closest(".dx-ctrlpagepopupdiv")[0]) : container))).dxCtrlJauge({}).dxCtrlJauge("instance")
        //jauge.mShow();

        mRempliBt()

        $DivEntete = $("<div style='width:100%;box-sizing:border-box;'/>").appendTo(container)
        if (parametre.isMobile) option.optionPopup.toolbar.element().appendTo($DivEntete)

        if (parametre.isMobile) $DivEntete.css("padding", "0 10px")

        if (option.data.id_com_email_envoi_repondre != null || option.data.id_com_email_envoi_repondre_tous != null || option.data.id_com_email_envoi_transfert != null) {
            var dataRepondre = null
            if (option.data.id_com_email_envoi_repondre != null) dataRepondre = option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi_repondre).data
            var dataRepondreTous = null
            if (option.data.id_com_email_envoi_repondre_tous != null) dataRepondreTous = option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi_repondre_tous).data
            var dataRepondreTransfert = null
            if (option.data.id_com_email_envoi_transfert != null) dataRepondreTransfert = option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi_transfert).data
            //dataRepondre.date_envoi = new Date()
            //dataRepondreTous.date_envoi = new Date()
            //dataRepondreTransfert.date_envoi = new Date()
            $("<div style='margin:0 2px 2px 2px'/>").appendTo($DivEntete).dxCtrlWarningForm({
                type: "info",
                allowClose: true,
                contentTemplate: function (contentElement) {
                    if (dataRepondre != null && dataRepondre.date_envoi != null) {
                        var $a = $("<a href='javascript:void(0)'>Vous avez <b>répondu</b> le " + dataRepondre.date_envoi.toFrenchDateTime().replace(" ", " à ") + "</a>").appendTo(contentElement)
                        $a.on("click", function () { option.bddCtrl.getObjet(dataRepondre).mShowPopup() })
                    }
                    if (dataRepondreTous != null && dataRepondreTous.date_envoi != null) {
                        if (dataRepondre != null && dataRepondre.date_envoi != null) { $("<br/>").appendTo(contentElement) }
                        var $a = $("<a href='javascript:void(0)'>Vous avez <b>répondu à tous</b> le " + dataRepondreTous.date_envoi.toFrenchDateTime().replace(" ", " à ") + "</a>").appendTo(contentElement)
                        $a.on("click", function () { option.bddCtrl.getObjet(dataRepondreTous).mShowPopup() })
                    }
                    if (dataRepondreTransfert != null && dataRepondreTransfert.date_envoi != null) {
                        if ((dataRepondre != null && dataRepondre.date_envoi != null) || (dataRepondreTous != null && dataRepondreTous.date_envoi != null)) { $("<br/>").appendTo(contentElement) }
                        var $a = $("<a href='javascript:void(0)'>Vous avez <b>transféré</b> ce mail le " + dataRepondreTransfert.date_envoi.toFrenchDateTime().replace(" ", " à ") + "</a>").appendTo(contentElement)
                        $a.on("click", function () { option.bddCtrl.getObjet(dataRepondreTransfert).mShowPopup() })
                    }
                }
            }).dxCtrlWarningForm("instance")
        }

        mRempliDest()

        var $DivObjet = $("<div style='width:100%;padding:2px;'/>").appendTo($DivEntete)
        var $Table = $("<table style='width:100%;'/>").appendTo($DivObjet)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdObjet = $("<td style='width:100%;border-bottom:" + theme.border + ";'/>").appendTo($Tr)
        $("<div/>").appendTo($TdObjet).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Objet",
            width: "100%",
            readOnly: true,
            value: option.data.objet
        }).dxCtrlTextBox("instance")
        //var $DivObjet = $("<div style='margin:10px;font-size:150%;font-style:italic;'></div>").appendTo($Td)
        //$DivObjet.text(option.data.objet)

        var dxSelectProjet = null
        if (option.bddCtrl.objCptCli.objetMetier.hasProjet() && !parametre.isMobile) {
            if (option.bddCtrl.utiCourantParaJson.parametre_general.email_afficher_selection_projet_dans_fenetre) {
                $TdObjet.css("width", "75%")
                var $Td = $("<td style='width:25%;'/>").appendTo($Tr)
                dxSelectProjet = $("<div style='padding-left:10px;'/>").appendTo($Td).dxCtrlSelectProjet({
                    bddCtrl: option.bddCtrl,
                    data: option.data
                })
            }
        }

        if (option.bddCtrl.utiCourantParaJson.parametre_general.email_afficher_selection_classeur_dans_fenetre && !parametre.isMobile) {
            $TdObjet.css("width", ((dxSelectProjet) ? "50%" : "75%"))
            var $TdClasseur = $("<td style='width:25%;'/>").appendTo($Tr)
            var obj = option.bddCtrl.getObjet(option.data)
            $("<div/>").appendTo($TdClasseur).dxCtrlSelectClasseur({
                bddCtrl: option.bddCtrl,
                idTable: option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table,
                id: obj.cle(),
                onDemandeSave: function (funcSaved) {
                    var obj = option.bddCtrl.getObjet(option.data)
                    obj.mSave(function () { if (typeof funcSaved != 'undefined') funcSaved(obj.cle()) })
                }
            })
        }

        var $DivFichier = $("<div style='width:100%;margin:2px;'/>").appendTo($DivEntete)
        option.bddCtrl.mAjaxCall({
            command: "getlstfilejointemailrecu",
            id_com_email_recu: option.data.id_com_email_recu
        }, function (data) {
            if (typeof data.lstFile == 'undefined' || data.lstFile.length == 0) { }
            else {
                $("<div/>").appendTo($DivFichier).dxCtrlFichier2Document({
                    bddCtrl: option.bddCtrl,
                    dataSource: data.lstFile,
                    readOnly: true
                })
            }
        })

        //option.bddCtrl.mAjaxCall({ command: "getnamefileemail", idcomrecu: option.data.id_com_email_recu }, function (data) { })
        var $DivDoc = $("<div style='background-color:white;width:100%;border:" + theme.border + ";'/>").appendTo(container)
        resizeObserver.mAdd($DivEntete, function () { $DivDoc.css("height", "calc(100% - " + ($DivEntete.innerHeight() + 2) + "px)") })()


        var $EleDoc = $("<iframe src='/handler/handlerinterne.ashx?command=gethtmlemail&idcomrecu=" + option.data.id_com_email_recu + "' style='border-radius:3px;box-sizing:border-box;border:none;display:inline-block;opacity:0;height:100%;width:100%;'/>").appendTo($DivDoc)

        var iframeLoaded = false;
        $EleDoc.on("load", function () {
            iframeLoaded = true;
            $EleDoc.animate({ "opacity": 1 }, 150); jauge.mHide(150)
            $EleDoc.contents().on("click", function (e) {
                container.trigger(e);
            });
        })
        // fallback : pas d’erreur sur iframe → on utilise un timeout
        setTimeout(function () {
            if (!iframeLoaded) {
                $EleDoc.animate({ opacity: 1 }, 150);
                jauge.mHide(150);
                console.warn("Iframe timeout");
            }
        }, 5000);
        
        //$EleDoc.addClass("ph-no-capture")
        $EleDoc.attr("src", "/handler/handlerinterne.ashx?command=gethtmlemail&idcomrecu=" + option.data.id_com_email_recu + "")
    }

    var lstItemToolBarSource = null
    function mRempliBt() {

        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []


        if (parametre.isMobile) {
            itemsToolbar.push(getToolbarSeparator())
            itemsToolbar.push({
                location: 'before',
                locateInMenu: 'never',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-xmark",
                        txtTooltip: "Fermer",
                        onClick: function (e) {
                            page.mRemovePopup(option.data)
                        }
                    });
                },
            })
        }

        itemsToolbar.push({
            location: ((parametre.isMobile) ? 'before' : 'after'),
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<span style='font-size:160%;' title='Reçu le: " + option.data.date_reception.toFrenchDateTime() + "'>&nbsp;" + option.data.date_reception.toDateIlya(true) + "</span>").appendTo(itemElement)
            },
        })
        if (parametre.isMobile) {
            itemsToolbar.push(getToolbarSeparator("before"))
            itemsToolbar.push({
                location: 'before',
                locateInMenu: 'never', //'auto',
                visible: parametre.isMobile,
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-boxes-packing",
                        txtTooltip: "Déplacer",
                        //width: 40,
                        //height: 40,
                        onClick: function (e) {
                            var ds = [{ text: "Mettre en boite de réception", icon: "fas fa-inbox" },
                            { text: "Archiver", icon: "fas fa-box-archive" },
                            { text: "SPAM", icon: "fas fa-shield" },
                            { text: "Corbeille", icon: "fas fa-trash-alt" }]
                            switch (parseInt(option.data.id_type_classement)) {
                                case 1: ds.splice(0, 1); break;
                                case 2: ds.splice(1, 1); break;
                                case 3: ds.splice(2, 1); break;
                                case 4: case 5: case 6: ds.splice(2, 1); break;
                            }
                            var actionSheet = $("<div style='z-index:" + (mGetMaxZindexElement($("body")) + 1) + ";'/>").appendTo("body").dxActionSheet({
                                dataSource: ds,
                                title: 'Répondre...',
                                onCancelClick() {
                                },
                                onOptionChanged: function (e) {
                                    debugger;
                                    if (e.name === "visible" && e.value === false) {
                                        e.component.element().remove()
                                    }
                                },
                                onItemClick(value) {
                                    //jauge.mShow()
                                    switch (value.itemData.text) {
                                        case "Mettre en boite de réception":
                                            option.bddCtrl.mAjaxCall({
                                                command: "deplacecommunication",
                                                table_source: "com_email_recu",
                                                lst_element: [{ id_table: option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table, id: option.data.id_com_email_recu }],
                                                id_classeur: null,
                                                from_sous_type: "",
                                                to_sous_type: "reception"
                                            }, function (data) {
                                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr")
                                                mNotify("Votre email a été mis en <b>boite de reception</b>", "success", 6000)
                                            })
                                            page.mRemovePopup(option.data)
                                            actionSheet.element().remove()
                                            break;
                                        case "Archiver":
                                            option.bddCtrl.mAjaxCall({
                                                command: "deplacecommunication",
                                                table_source: "com_email_recu",
                                                lst_element: [{ id_table: option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table, id: option.data.id_com_email_recu }],
                                                id_classeur: null,
                                                from_sous_type: "",
                                                to_sous_type: "archivage"
                                            }, function (data) {
                                                option.bddCtrl.msgEmailSms.mGetData(true)
                                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr")
                                                mNotify("Votre email a été <b>archivé</b>", "success", 6000)
                                            })
                                            page.mRemovePopup(option.data)
                                            actionSheet.element().remove()
                                            break;
                                        case "SPAM":
                                            option.bddCtrl.mAjaxCall({
                                                command: "deplacecommunication",
                                                table_source: "com_email_recu",
                                                lst_element: [{ id_table: option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table, id: option.data.id_com_email_recu }],
                                                id_classeur: null,
                                                from_sous_type: "",
                                                to_sous_type: "antispam"
                                            }, function (data) {
                                                option.bddCtrl.msgEmailSms.mGetData(true)
                                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr")
                                                mNotify("Votre email a été <b>mis en SPAM</b>", "success", 6000)
                                            })
                                            page.mRemovePopup(option.data)
                                            actionSheet.element().remove()
                                            break;
                                        case "Corbeille":
                                            option.bddCtrl.getObjet(option.data).mDelData(function (data) {
                                                option.bddCtrl.msgEmailSms.mGetData(true)
                                                mNotify("Votre email a été <b>mis à la corbeille</b>", "success", 6000)
                                            })
                                            page.mRemovePopup(option.data)
                                            actionSheet.element().remove()
                                            break;
                                    }
                                },
                                onItemRendered: function (e) {
                                    e.itemElement.find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                                },
                                onContentReady: function (e) {
                                    $("body").find(".dx-actionsheet-popup-wrapper").on("click", function () {
                                        e.component.hide()
                                    })
                                }
                            }).dxActionSheet('instance');
                            actionSheet.option('visible', true);
                        }
                    });
                },
            })
            itemsToolbar.push(getToolbarSeparator("before"))
            itemsToolbar.push({
                location: 'before',
                locateInMenu: 'never', //'auto',
                visible: parametre.isMobile,
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-envelope-open",
                        txtTooltip: "Répondre",
                        icon2: "fas fa-reply",
                        colorIcone2: theme.backgroundcolorAccent,
                        //width: 40,
                        //height: 40,
                        onClick: function (e) {
                            var actionSheet = $("<div style='z-index:" + (mGetMaxZindexElement($("body")) + 1) + ";'/>").appendTo("body").dxActionSheet({
                                dataSource: [{ text: "Répondre", icon: "fas fa-reply" }, { text: "Répondre à tous", icon: "fas fa-reply-all" }, { text: "Transférer", icon: "fas fa-share" }],
                                title: 'Répondre...',
                                onCancelClick() {
                                },
                                onOptionChanged: function (e) {
                                    if (e.name === "visible" && e.value === false) {
                                        e.component.element().remove()
                                    }
                                },
                                onItemClick(value) {
                                    jauge.mShow()
                                    switch (value.itemData.text) {
                                        case "Répondre":
                                            option.bddCtrl.mAjaxCall({ command: "repondrerecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                                option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr") //pour la sauvegarde de DMO
                                                page.mRemovePopup(option.data)
                                                jauge.mHide()
                                            })
                                            actionSheet.element().remove()
                                            break;
                                        case "Répondre à tous":
                                            option.bddCtrl.mAjaxCall({ command: "repondreatousrecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                                option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr") //pour la sauvegarde de DMO
                                                page.mRemovePopup(option.data)
                                                jauge.mHide()
                                            })
                                            actionSheet.element().remove()
                                            break;
                                        case "Transférer":
                                            option.bddCtrl.mAjaxCall({ command: "transfererecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                                page.mRemovePopup(option.data, function () {
                                                    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                                    option.bddCtrl.getObjet(option.data).mSaveChamp("dcr") //pour la sauvegarde de DMO
                                                    jauge.mHide()
                                                })
                                            })
                                            actionSheet.element().remove()
                                            break;
                                    }
                                },
                                onItemRendered: function (e) {
                                    e.itemElement.find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                                },
                                onContentReady: function (e) {
                                    $("body").find(".dx-actionsheet-popup-wrapper").on("click", function () {
                                        e.component.hide()
                                    })
                                }
                            }).dxActionSheet('instance');
                            actionSheet.option('visible', true);
                        }
                    });
                },
            })
        } else {
            itemsToolbar.push(getToolbarSeparator())
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                visible: !parametre.isMobile,
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-envelope-open",
                        txtTooltip: "Répondre",
                        icon2: "fas fa-reply",
                        colorIcone2: theme.backgroundcolorAccent,
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            jauge.mShow()
                            option.bddCtrl.mAjaxCall({ command: "repondrerecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                page.mRemovePopup(option.data, function () {
                                    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                    option.bddCtrl.getObjet(option.data).mSaveChamp("dcr") //pour la sauvegarde de DMO
                                    jauge.mHide()
                                })
                            })
                        }
                    });
                },
            })
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'always', //'auto',
                visible: !parametre.isMobile,
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-envelope-open",
                        txtTooltip: "Répondre à tous",
                        icon2: "fas fa-reply-all",
                        colorIcone2: theme.backgroundcolorAccent,
                        text: "Répondre à tous",
                        width: "100%",
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            jauge.mShow()
                            option.bddCtrl.mAjaxCall({ command: "repondreatousrecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                page.mRemovePopup(option.data, function () {
                                    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                    option.bddCtrl.getObjet(option.data).mSaveChamp("dcr") //pour la sauvegarde de DMO
                                    jauge.mHide()
                                })
                            })
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    });
                },
            })
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'always', //'auto',
                visible: !parametre.isMobile,
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-envelope-open",
                        txtTooltip: "Transférer",
                        icon2: "fas fa-share",
                        colorIcone2: theme.backgroundcolorAccent,
                        text: "Transférer",
                        width: "100%",
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            jauge.mShow()
                            option.bddCtrl.mAjaxCall({ command: "transfererecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                page.mRemovePopup(option.data, function () {
                                    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                    option.bddCtrl.getObjet(option.data).mSaveChamp("dcr") //pour la sauvegarde de DMO
                                    jauge.mHide()
                                })
                            })
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    });
                },
            })

            itemsToolbar.push(getToolbarSeparator("after", "always"))
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'always', //'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-inbox",
                        txtTooltip: "mettre en <b>boite de réception</b>",
                        icon2: "fas fa-angle-down",
                        colorIcone2: theme.backgroundcolorAccent,
                        text: "mettre en boite de réception",
                        width: "100%",
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            option.bddCtrl.mAjaxCall({
                                command: "deplacecommunication",
                                table_source: "com_email_recu",
                                lst_element: [{ id_table: option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table, id: option.data.id_com_email_recu }],
                                id_classeur: null,
                                from_sous_type: "",
                                to_sous_type: "reception"
                            }, function (data) {
                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr")
                                mNotify("Votre email a été mis en <b>boite de reception</b>", "success", 6000)
                            })
                            //option.data.id_type_classement = "1"
                            //option.bddCtrl.getObjet(option.data).mSaveChamp("id_type_classement")
                            //page.mRemovePopup(option.data)
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    }).dxCtrlButton("instance");
                },
            })
            var dxBtRecept = itemsToolbar[itemsToolbar.length - 1]

            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'always', //'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-box-archive",
                        txtTooltip: "mettre en <b>archive</b>",
                        icon2: "fas fa-angle-down",
                        text: "mettre en archive",
                        width: "100%",
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            option.bddCtrl.mAjaxCall({
                                command: "deplacecommunication",
                                table_source: "com_email_recu",
                                lst_element: [{ id_table: option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table, id: option.data.id_com_email_recu }],
                                id_classeur: null,
                                from_sous_type: "",
                                to_sous_type: "archivage"
                            }, function (data) {
                                option.bddCtrl.msgEmailSms.mGetData(true)
                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr")
                                mNotify("Votre email a été <b>archivé</b>", "success", 6000)
                            })
                            //page.mRemovePopup(option.data)
                            //option.data.id_type_classement = "2"
                            //option.data.nouveau = "0"
                            //option.bddCtrl.getObjet(option.data).mSave()
                            //page.mRemovePopup(option.data)
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    }).dxCtrlButton("instance");
                },
            })
            var dxBtArchive = itemsToolbar[itemsToolbar.length - 1]

            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'always', // 'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-shield",
                        txtTooltip: "mettre en <b>spam</b>",
                        icon2: "fas fa-angle-down",
                        text: "mettre en spam",
                        width: "100%",
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            option.bddCtrl.mAjaxCall({
                                command: "deplacecommunication",
                                table_source: "com_email_recu",
                                lst_element: [{ id_table: option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table, id: option.data.id_com_email_recu }],
                                id_classeur: null,
                                from_sous_type: "",
                                to_sous_type: "antispam"
                            }, function (data) {
                                option.bddCtrl.msgEmailSms.mGetData(true)
                                option.bddCtrl.getObjet(option.data).mSaveChamp("dcr")
                                mNotify("Votre email a été <b>mis en SPAM</b>", "success", 6000)
                            })
                            page.mRemovePopup(option.data)
                            //option.data.id_type_classement = "3"
                            //option.bddCtrl.getObjet(option.data).mSaveChamp("id_type_classement")
                            //page.mRemovePopup(option.data)
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    }).dxCtrlButton("instance");
                },
            })
            var dxBtSpam = itemsToolbar[itemsToolbar.length - 1]
            itemsToolbar.push(getToolbarSeparator("after", "always"))

            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'always', //'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-print",
                        txtTooltip: "Imprimer",
                        text: "Imprimer",
                        width: "100%",
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            jauge.mShow();
                            jauge.option("message", "Génération de l'impression")
                            option.bddCtrl.mAjaxCall({ command: "printemailrecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                                $("<div/>").appendTo("body").dxCtrlViewer({
                                    bddCtrl: option.bddCtrl,
                                    value: [data.urlpdf],
                                    indexCourant: 0
                                })
                                jauge.mHide();
                            })
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    });
                },
            })

            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'always', //'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-cloud-arrow-up",
                        txtTooltip: "Télécharger le mail",
                        text: "Télécharger le mail",
                        width: "100%",
                        //width: HeightButton,
                        //height: HeightButton,
                        onClick: function (e) {
                            jauge.mShow();
                            jauge.option("message", "Téléchargement du mail")
                            option.bddCtrl.mAjaxCall({ command: "downloademailrecu", id_com_email_recu: option.data.id_com_email_recu }, function (data) {
                                if (data.urleml.startsWith("~")) data.urleml = data.urleml.substring(1)
                                window.open(data.urleml, "_blank")
                                jauge.mHide();
                            })
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    });
                },
            })

            switch (parseInt(option.data.id_type_classement)) {
                case 1: dxBtRecept.visible = false; break;
                case 2: dxBtArchive.visible = false; break;
                case 3: dxBtSpam.visible = false; break;
                case 4: case 5: case 6: dxBtSpam.visible; break;
            }
        }

        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Mettre à la corbeille",
                    //width: HeightButton,
                    //height: HeightButton,
                    onClick: function (e) {
                        if (typeof option.optionPopup.onDelete != 'undefined') option.optionPopup.onDelete()
                        option.bddCtrl.getObjet(option.data).mDelData()
                        page.mRemovePopup(option.data)
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)

    }

    function mRempliDest() {
        $("<div style='margin:2px;'/>").appendTo($DivEntete).dxCtrlTagBoxDestinataireEmail({
            bddCtrl: option.bddCtrl,
            data: option.data
        }).dxCtrlTagBoxDestinataireEmail("instance")
    }

    this.element = function () { return container }

    mConstruit();
}